let holder
let item
let cartCount

let productForm

let timeout

export function AddToCartBtn(context = document) {
    holder = context.createElement('div')
    cartCount = context.querySelector('#CartCount')

    productForm = context.querySelector('.js-product-form')

    document.addEventListener('click', (evt) => {
        if (evt.target.classList.contains('js-add-cart-btn')) {
            handleAddToCart(evt)
        }

        if (evt.target.classList.contains('js-notification-close')) {
            close()
        }
    })

    if (productForm) {
        productForm.addEventListener('submit', handleProductSubmit)
    }
}

function handleProductSubmit(evt) {
    evt.preventDefault()

    const formData = new FormData(productForm)
    console.log(Array.from(formData.entries()))
    const id = formData.get('id')
    const image = formData.get('image')
    const title = formData.get('title')
    const quantity = formData.get('quantity')

    addToCart(id, image, title, quantity)
}

function handleAddToCart(evt) {
    evt.preventDefault()

    const { id, image, title } = evt.target.dataset

    addToCart(id, image, title)
}

function addToCart(id, image, title, quantity = 1) {
    let formData = {
        items: [
            {
                quantity,
                id: id
            }
        ]
    }

    fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    })
        .then((res) => res.json())
        .then((res) => {
            cartCount.innerText = +cartCount.innerText + res.items.length
            createNotification(image, title)
            showNotification()
        })
        .catch(console.error)
}

function createNotification(image, title) {
    if (item) {
        holder.appendChild(item)
    }

    holder.innerHTML = `
        <div class="c-notification js-notification" role="alert" aria-live="assertive">
            <button class="c-notification__close js-notification-close">
                <span class="u-visually-hidden">Close alert</span>
                <svg xmlns="http://www.w3.org/2000/svg" width="150" height="150" viewBox="0 0 150 150">
                    <path fill="currentColor" d="M124.6 114.1 85.5 75l39-39.1c4.9-4.8 6.4-11.1 3.5-14s-9-1.3-13.9 3.5L75 64.5l-39.1-39c-4.8-4.9-11.1-6.4-14-3.5s-1.3 9 3.5 13.9L64.5 75l-39 39.1c-4.9 4.8-6.4 11-3.5 14 2.8 2.8 9 1.3 13.9-3.5L75 85.5l39.1 39c4.8 4.9 11 6.4 14 3.5 2.8-2.8 1.3-9-3.5-13.9Z"></path>
                </svg>
            </button>
            <img src="${image}" alt="${title}">
            <div class="c-notification__content">
                <h5>Added to cart</h5>
                <p>${title}</p>
                <a href="${window.rootUrl || ''}/cart">View cart</a>
            </div>
        </div>
    `
}

function showNotification() {
    item = holder.firstElementChild
    document.body.appendChild(item)

    requestAnimationFrame(() => {
        item.classList.add('is-open')
    })

    timeout = setTimeout(() => {
        close()
    }, 3500)
}

function close() {
    clearTimeout(timeout)
    item.classList.remove('is-open')
}
